"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeCampagne", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./homeCampagne.html"),
    controller: function controller($scope, $http, $dialogBox, $dateFormat) {
      $scope.reponseInvitation = {};
      var load = function load() {
        $http.get('/rest/home/get-info-campagne-utilisateur').then(function (response) {
          // contient "" si aucune campagne pour l'utilisateur
          $scope.campagne = response.data;
          $scope.reponseInvitation = {
            reponse: 'VIENDRA',
            sessionId: null,
            journee: 'COMPLETE'
          };
          if ($scope.campagne && $scope.campagne.sessions.length === 1) {
            $scope.reponseInvitation.sessionId = $scope.campagne.sessions[0].id;
          }
          $scope.reponsesInvitationCampagne = [{
            id: 'VIENDRA',
            label: 'Je viendrai'
          }, {
            id: 'NE_VIENDRA_PAS',
            label: 'Je ne viendrai pas'
          }];
          $scope.journeesCampagne = [{
            id: 'COMPLETE',
            label: 'Journée Complète'
          }, {
            id: 'MATIN',
            label: 'Matin'
          }, {
            id: 'APRES_MIDI',
            label: 'Après-midi'
          }];
          $scope.sessions = _.map($scope.campagne.sessions, function (c) {
            var label = _.upperFirst($dateFormat.date(c.date));
            if (c.heure) {
              label += " " + c.heure + "h";
              if (c.minutes) {
                label += c.minutes;
              }
            }
            if (c.lieu) {
              label += " - " + c.lieu;
            }
            return {
              id: c.id,
              label: label
            };
          });
        });
      };
      load();
      $scope.envoiReponseInvitation = function () {
        if ($scope.submit) {
          return;
        }
        $scope.submit = true;
        $http.post('/rest/home/save-campagne-utilisateur/' + $scope.campagne.id, null, {
          params: $scope.reponseInvitation
        }).then(function () {
          return $dialogBox.alert({
            title: "Participation enregistrée",
            text: "Votre réponse a bien été enregistrée. Si vous deviez changer d'avis, merci de contacter votre consultant pour l'en informer."
          }).then(function () {
            load();
          });
        }).finally(function () {
          $scope.submit = false;
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/campagne/homeCampagne.js
// module id = 2787
// module chunks = 13